






















































import { Component, Vue } from "vue-property-decorator";
import { LoadFromJson, LoadFromJsonType } from "../store";
import Game from "./Game.vue";

@Component({
  components: { Game },
})
export default class Wrapper extends Vue {
  modalShow = false;
  loadType = LoadFromJsonType.load;
  stopMove = "";
  text = "";
  replayData: { stard: number; end: number; current: number } | null = null;
  dark = false;

  // The dev harness plays the host page's role: it owns the "dark" class on <html>
  // (the viewer's dark stylesheet reacts to it) and persists the choice.
  applyDark() {
    document.documentElement.classList.toggle("dark", this.dark);
    localStorage.setItem("theme", this.dark ? "dark" : "light");
  }

  toggleDark() {
    this.dark = !this.dark;
    this.applyDark();
  }

  handleOK() {
    this.$store.dispatch("loadFromJSON", {
      engineData: JSON.parse(this.text),
      type: this.loadType,
      stopMove: this.stopMove,
    } as LoadFromJson);
  }

  openExport() {
    this.text = JSON.stringify(this.$store.state.data);
    this.modalShow = true;
  }

  startReplay() {
    this.$store.dispatch("replayStart");
  }

  replayTo(dest: number) {
    this.$store.dispatch("replayTo", dest);
  }

  endReplay() {
    this.$store.dispatch("replayEnd");
    this.replayData = null;
  }

  mounted() {
    const stored = localStorage.getItem("theme");
    this.dark = stored ? stored === "dark" : window.matchMedia("(prefers-color-scheme: dark)").matches;
    this.applyDark();

    const unsub = this.$store.subscribeAction(({ type, payload }) => {
      if (type === "replayInfo") {
        this.replayData = payload;
      }
    });
    this.$on("hook:beforeDestroy", unsub);
  }
}
